/* eslint-disable max-len */

import TableList from '@/inheritance/table-list';

export default {
  /**
   * Nombre del componente
   */
  name: 'IntervenersList',

  /**
   * Extendemos la funcionalidad del listado de tablas desde src/inheritance/table-list.js
   */
  extends: TableList,

  /**
   * @override
   */
  props: {
    id: {
      type: String,
      required: false
    }
  },

  /**
   * @override
   */
  data() {
    return {
      defaultColumns: [
        'id_object',
        'lastname_1',
        'lastname_2',
        'name',
        'document_type',
        'document_id',
        'intervener_type',
        'birthdate',
        'created_on',
        'email',
        'home_phone',
        'intervener_status',
        'data_protection_send_info',
        'intervener_issues_count',
        'has_active_position',
        'external_code'
      ],
      defaultModificationsMonitorColumns: ['id_object', 'document_type', 'document_id', 'name', 'lastname_1', 'lastname_2','has_draft_data', 'has_docs_pending_validation'],
      listSearching: false,
      downloadingDocuments: [],
      loading: false
    };
  },
  /**
   * @override
   */
  beforeMount() {
    this.section = 'interveners';
    this.loadSectionViews();
  },

  /**
   * Configuración inicial del componente
   * 1. Asignamos las columnas por defecto del listado de la tabla
   * 2. Obtenemos los filtros que el usuario pueda haber aplicado con anterioridad
   * 3. Obtenemos la información de la tabla
   */
  mounted() {
    this.$root.$off('downloading');
    this.$root.$on('downloading', uuids => {
      this.downloadingDocuments = uuids;
    });
    this.$root.$off('updateItems');
    this.$root.$on('updateItems', () => {
      this.loadItems();
      this.downloadingDocuments = [];
    });
    if (this.id) {
      const filter = {
        field: 'uuid_account',
        condition: 'in',
        conditionValue: this.id
      };
      this.tbFilters = [filter];
      this.addFiltersToRequest(this.tbFilters);
      this.loadItems();
    } else {
      this.tbFilters = this.loadFilterInLocalstore('filt_int');
      this.orderby = this.loadFilterInLocalstore('ob_int');
      this.search = this.loadFilterInLocalstore('search_int');

      this.addFiltersToRequest(this.tbFilters);

      const storedView = JSON.parse(localStorage.getItem(`table_view_selected_${this.$route.name}`));
      if (storedView) {
        this.loadView(storedView);
      } else if (
        this.orderby &&
        this.orderby !== 'false' &&
        this.orderby.length > 0 &&
        this.orderby !== this.$route.query['sorts-by']
      ) {
        const query = { 'sorts-by': this.orderby };
        this.$router
          .replace({
            path: this.$route.path,
            query
          })
          .then(() => {
            this.sort(this.orderby);
          });
      } else {
        this.loadItems();
      }
      this.columns = this.loadFilterInLocalstore('col_int');
    }
  },
  beforeDestroy() {
    this.$root.$off('updateItems');
    this.$root.$off('downloading');
  },
  methods: {
    rowCanBeValidated(row) {
      const status = row.intervener_status;
      const isRegistered = status.includes('REGISTERED');
      const isNotRegisteredPostal = status !== 'REGISTERED_POSTAL';
      const isSigned = status === 'SIGNED';
      return (
        (row.can_be_validated && ((isRegistered && isNotRegisteredPostal) || isSigned)) ||
        (row.has_docs_been_downloaded && (isRegistered || isSigned))
      );
    },
    canRowDisplayContextMenu(row) {
      return (
        row.can_be_validated ||
        row.intervener_status === 'VALIDADO' ||
        (this.$refs.table && this.$refs.table.isAllowedToExecuteBatchDownloads)
      );
    },
    /**
     * Obtenemos la lista de interveners desde el servicio
     * @param {String} sort Orden asc/desc
     * @param {Object} cfg Configuración de filtros
     */
    loadItems(sort = this.orderby, cfg = {}) {
      if (this.filters && Object.keys(this.filters).length) {
        cfg.params = {
          $filter: JSON.stringify(this.filters)
        };
      }

      const payload = {
        section: 'interveners',
        cfg
      };

      if (sort && sort !== 'false') {
        payload.sort = sort;
    }

      this.listSearching = true;
      this.loadData(payload)
        .then(res => {
          this.metadata = res.metadata;
          this.items = this.mapSelfName(res.data.interveners, ['name', 'lastname_1', 'lastname_2']);

          this.getColumns();
          this.filterColums();

          const changedColumns = this.loadFilterInLocalstore('col_int');
          if (!changedColumns.length) {
            this.orderColumns();
          }

          if (this.$route.query['modifications-monitor']) {
            this.columns = this.columns.filter(
              col => !['uuid', 'intervener_status'].includes(col.field)
            );
            this.items = this.items.filter( item => item.has_draft_data === true || item.has_docs_pending_validation === true )
          }
          this.calculateColumnsWith(this.columns);
        })
        .catch(err => this.$toast.error(`Error ${err.name}`, `${err.message}`))
        .finally(() => {
          this.listSearching = false;
          this.$nextTick(() => {
            if (!this.tableHasScroll()) {
              this.infiniteScroll();
            }
          });
        });
    },

    /**
     * Ordenamos la tabla por un campo específico
     * @param {String} field Orden de la tabla
     */
    sort(field) {
      this.orderby = field;
      let cfg = {};
      if (this.filters && Object.keys(this.filters).length) {
        cfg = {
          params: {
            $filter: JSON.stringify(this.filters)
          }
        };
      }
      this.loadItems(field, cfg);
      if (field && field !== 'false') {
        this.saveFilterInLocalstore(field, 'ob_int');
      } else {
        this.removeFromLocalstore('ob_int');
      }
    },

    /**
     * FILTRO DE RESULTADOS
     * Aplicamos los filtros seleccionados. Guardamos en localStore una variable con los filtros aplicados,
     * para que cuando el usuario cambie de sección y vuelva de nuevo a este listado, se carguen
     * los resultados que había filtrado.
     * @param {Array} filters Filtros para aplicar
     */
    filter(filters) {
      if (!this.id) {
        this.saveFilterInLocalstore(filters, 'filt_int');
      }
      if (filters.length >= 1) {
        this.tbFilters = filters;
        this.applyFilters(filters);
        const cfg = {
          params: {
            $filter: JSON.stringify(this.filters)
          }
        };
        this.loadItems(this.orderby, cfg);
      } else {
        delete this.filters;
        this.loadItems();
      }
    },

    /**
     * SCROLL INFINITO
     * Método que se ejecuta cuanto el usuario ha hecho scroll y ha llegado al final de la tabla.
     * Se llama al método heredado 'pagination' y devuelve un array de resultados, los cuales
     * se 'mezclan' con los resultados que tenía la tabla.
     */
    infiniteScroll() {
      if (this.listSearching) {
        return;
      }
      const payload = {
        section: 'interveners',
        href: this.metadata.paging._links._next.href
      };
      if (payload.href && !this.isLoading && this.$route.query['modifications-monitor']) {
        payload.href += `&modifications-monitor=${this.$route.query['modifications-monitor']}`;
      }
      if (payload.href && !this.isLoading) {
        this.pagination(payload)
          .then(res => {
            this.metadata = res.metadata;
            this.items = [
              ...this.items,
              ...this.loadDataInTable(res.data.interveners, ['name', 'lastname_1', 'lastname_2'])
            ];
          })
          .catch(err => this.$toast.error(`Error ${err.name}`, `${err.message}`));
      }
    },

    /**
     * @override
     */
    colsChange(cols) {
      this.columns = cols;
      this.saveFilterInLocalstore(cols, 'col_int');
    },
    /**
     * Añade los filtros obtenidos de localStorage a la petición inicial
     * @param {Object} tbFilters filtros guardados en storage
     */
    addFiltersToRequest(tbFilters) {
      // Se añaden los filtros a la petición si están en el storage
      this.filters = [];
      tbFilters.forEach(filtro => {
        const condition = filtro.condition;
        this.filters.push({
          field: filtro.field,
          condition,
          conditionValue: filtro.conditionValue,
          orFilter: !!filtro.orFilter
        });
      });
      this.applyFilters(this.filters);
    },

    doSearch(val) {
      this.search = val;
      this.saveFilterInLocalstore(val, 'search_int');
      this.loadItems();
    },

    validateIntervener(intervener) {
      this.loading = true
      this.$intervenersService
        .changeIntervenerStatus(intervener.uuid, { status: 'VALIDADO' })
        .then(() => {
          this.$toast.success(`Ok`, `${intervener._self_name} validado correctamente`);
          this.loadItems();
        })
        .catch(() => {
          this.$toast.error(`Error`, `Error al validar a ${intervener._self_name}`);
        })
        .finally(() => this.loading = false)
    },

    async sendIntervenerToRD(intervener) {
      if (intervener.intervener_status === 'VALIDADO') {
        this.loading = true
        try {
          await this.$intervenersService.changeIntervenerStatus(intervener.uuid, {
            status: 'ENVIADO',
            sendToRD: true
          });
          this.$toast.success(`Ok`, `${intervener._self_name} validado correctamente`);
          this.loadItems();
        } catch (err) {
          this.$toast.error(`Error ${err.name}`, `${err.message}`);
        }
        this.loading = false
      }
    },

    filterColums() {
      this.columns = this.columns.filter(col => {
        return ![
          'aml_checked_on',
          'aml_code',
          'aml_description',
          'aml_evidence',
          'aml_warning',
          'can_be_validated',
          'can_be_sent_to_rd',
          'contact_draft_data',
          'contact_language',
          'data_protection_analyze_operations',
          'data_protection_send_communications',
          'data_protection_surveys',
          'data_protection_value_school',
          'deleted_on',
          'document_front_thumbnail',
          'document_reverse_thumbnail',
          'facebook',
          'fiscal_draft_data',
          'f_address_door',
          'f_address_floor',
          'f_address_key_country',
          'f_address_key_state',
          'f_address_number',
          'f_address_street_2',
          'gdpr_indicator',
          'has_document_expired',
          'has_docs_been_downloaded',
          'has_docs_signed',
          'has_finveris_account',
          'instagram',
          'is_class_manual',
          'is_deleted',
          'is_disabled_person',
          'is_document_permanent',
          'is_minor',
          'is_web_access_authorized',
          'key_country_nationality2',
          'key_country_of_birth',
          'key_home_phone_prefix',
          'key_mobile_phone_prefix',
          'key_work_phone_prefix',
          'key_other_phone_prefix',
          'linkedin',
          '_links',
          'mailing_type',
          'matrimonial_regime',
          'onboarding_documents_to_sign_url',
          'other_phone',
          'personal_draft_data',
          'residence_start_date',
          'residence_end_date',
          '_self_name',
          'signed_onboarding_documents',
          'source_system',
          'twitter',
          'uuid_user',
          'uuid',
          'video_token',
          'work_phone'
        ].includes(col.field);
      });
    },

    orderColumns() {
      const columnsOrdered = [];
      const columnsOrder = [
        'uuid',
        'name',
        'lastname_1',
        'lastname_2',
        'gender',
        'birthdate',
        'city_of_birth',
        'key_country_of_birth',
        'key_nationality_1',
        'key_nationality_2',
        'deathdate',
        'marital_status',
        'matrimonial_regime',
        'disability_grade',
        'document_type',
        'document_id',
        'document_expiration_date',
        'has_done_private_area_first_login',
        'id_object',
        'intervener_type',
        'intervener_status',
        'intervener_issues_count',
        'videoidentification_status',
        'distributor',
        'subdistributor',
        'created_on',
        'class',
        'is_class_manual',
        'source_system',
        'key_home_phone_prefix',
        'home_phone',
        'key_mobile_phone_prefix',
        'mobile_phone',
        'email',
        'external_code',
        'mailing_type',
        'contact_language',
        'f_address_city',
        'f_address_door',
        'f_address_floor',
        'f_address_key_country',
        'f_address_state',
        'f_address_key_state',
        'f_address_number',
        'f_address_postal_code',
        'f_address_street_1',
        'f_address_street_2',
        'is_disabled_person',
        'is_document_permanent',
        'is_minor',
        'is_web_access_authorized',
        'can_be_sent_to_rd',
        'can_be_validated',
        'has_docs_been_downloaded',
        'gdpr_indicator',
        'data_protection_send_info',
        'has_docs_signed',
        'has_docs_validated',
        'has_document_expired',
        'has_draft_data',
        'has_docs_pending_validation',
        'has_active_position',
        'has_finveris_account'
      ];
      for (let index = 0; index < columnsOrder.length; index++) {
        const c = this.columns.find(x => x.name === columnsOrder[index]);
        if (c) {
          columnsOrdered.push(c);
        }
      }
      this.columns = columnsOrdered;
    },
    handleLoadView(view) {
      this.filters = null;
      this.tbFilters = [];
      this.orderby = '';
      this.removeFromLocalstore('filt_int');
      this.removeFromLocalstore('ob_int');
      this.removeFromLocalstore('col_int');
      this.removeFromLocalstore('search_int');
      this.loadView(view);
    }
  }
};
